function cleanApiUrl(value) {
  const url = String(value || '').trim().replace(/\/$/, '');
  if (!url || url === 'undefined' || !/^https?:\/\//i.test(url)) return '';
  return url;
}

/** Solo con esta env el REST `nuatalker` es Gen 2. Sin ella, Gen 1 no admite x-nua-*. */
export function isGen2NuatalkerConfigured() {
  return Boolean(cleanApiUrl(process.env.REACT_APP_NUATALKER_API));
}

/**
 * El API REST `nuatalker` de Amplify Gen 1 (`d6aj63xbgg…`) no tiene GET /audit.
 * Gen 2 vive en `nuatalker-backend-app` (nombre `nuatalker-dev` / sandbox).
 *
 * La URL sale de `amplify_outputs.json` tras `npm run sandbox` o del deploy de `dev`.
 * En local, `.env.local` y reiniciar `yarn start`:
 *   REACT_APP_NUATALKER_API=https://xxxx.execute-api.us-east-1.amazonaws.com/dev
 *   REACT_APP_NUATALKER_DIALER_API=https://yyyy.execute-api.us-east-1.amazonaws.com/dev
 * (sin slash final)
 */
export function applyGen2RestEndpoints(config) {
  if (!Array.isArray(config?.aws_cloud_logic_custom)) return config;
  const nuatalkerUrl = cleanApiUrl(process.env.REACT_APP_NUATALKER_API);
  const dialerUrl = cleanApiUrl(process.env.REACT_APP_NUATALKER_DIALER_API);
  if (!nuatalkerUrl && !dialerUrl) return config;
  return {
    ...config,
    aws_cloud_logic_custom: config.aws_cloud_logic_custom.map((api) => {
      if (api.name === 'nuatalker' && nuatalkerUrl) return { ...api, endpoint: nuatalkerUrl };
      if (api.name === 'dialer' && dialerUrl) return { ...api, endpoint: dialerUrl };
      return api;
    }),
  };
}
